<template>
  <li>
    <a
      :href="'/beispiel/' + getInstanceURI(this.item['instances'][0])"
      v-bind:class="[
               settings.sub2class, settings.sub2class + parentModel.category,
               item.position ? settings.sub2class + item.position : '',
               {'c-tile-nav__tile-sub2--active': isActive()},
               {'c-tile-nav__tile-sub2--inactive': !isActive()}
           ]"
      :data-color="parentModel.color"
      data-dir="--right"
      :data-title="item.title"
      v-on="{mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }"
      @click.prevent="setActive"
    >
      <span class="c-tile-nav__hidden-link">{{item.title}}</span>
    </a>
  </li>
</template>

<script>
import mixins from "../mixins";

export default {
  data() {
    return {};
  },
  mixins: [mixins],
  created: function() {
    store.commit("extendInstances", this.item["instances"]);
    store.commit("extendRelatedInstances", {
      modelId: this.parentModel.id,
      instances: this.item["instances"]
    });
  },
  computed: {
    settings() {
      return store.state.settings;
    },
    activeTask() {
      return store.state.runtime.activeItems["task"];
    }
  },
  methods: {
    setActive(event) {
      if (this.$store.state.runtime.activeItems.task === this.uid) return false;
      let uid = null;
      if (!this.isActive()) uid = this.uid;
      store.commit("unsetActiveItems");
      store.commit("setActiveItems", {
        type: "model",
        uid: this.parentModel.id
      });
      store.commit("setActiveItems", {
        type: "mechanism",
        uid: this.parentMechanism.id
      });
      store.commit("setActiveItems", { type: "task", uid: uid });
      store.commit("setActiveItems", {
        type: "instance",
        uid: this.item["instances"][0]
      });
      this.pushInstanceRoute(this.item["instances"][0])
    },
    isActive() {
      return this.uid === this.activeTask;
    }
  },
  model: {
    prop: "active",
    event: "change"
  },
  props: {
    // this allows using the `value` prop for a different purpose
    item: {
      type: Object
    },
    parentModel: {
      type: Object
    },
    parentMechanism: {
      type: Object
    },
    index: {
      type: Number
    },
    uid: {
      type: Number
    },
    // use `checked` as the prop which take the place of `value`
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>


// WEBPACK FOOTER //
// NavTask.vue?e055423a